import withContentFlags from '@/hoc/withContentFlags';
import Div from '@/shared/Div';
import React, { useCallback } from 'react';
import Map from '../Map';
import dlv from 'dlv';
import Container from '@/shared/Container';
import MenuNav from '@/shared/crisp/MenuNav';
import { getCategoryURL, getSellerCategoryUrl } from '@/utils/urls';
import { useAppConfigContext } from '@/context/AppContext';
import classNames from 'classnames';

interface CategoriesProps {
  list: { data: any[] };
  title: string;
  className?: string;
}

const Categories: React.FC<CategoriesProps> = ({ list, title, className }) => {
  const {
    state: { isSCAClient },
  } = useAppConfigContext();
  const render = useCallback((item: any, index: number) => {
    const { name, icon, categoryId } = dlv(item, 'attributes', {});
    return (
      <MenuNav
        key={categoryId}
        label={name}
        image={icon.data.attributes.url}
        href={getCategoryURL(categoryId, isSCAClient)}
      />
    );
  }, []);
  return (
    <Div className={classNames('bg-cs-secondary py-8', className)}>
      <Container className="text-cti-primary text-center ">
        <Div className="text-h-1 mb-6" dangerouslySetInnerHTML={{ __html: title }} />
        <Map className="flex justify-center flex-wrap" list={list.data} render={render} />
      </Container>
    </Div>
  );
};

export default withContentFlags(Categories);
